import { render, staticRenderFns } from "./elements-list.vue?vue&type=template&id=47f6e586&"
import script from "./elements-list.js?vue&type=script&lang=js&"
export * from "./elements-list.js?vue&type=script&lang=js&"
import style0 from "./elements-list.css?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./elements-list-vuetify.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBadge,VCard,VCardText})
